import { render, staticRenderFns } from "./nested-post-sidebar.vue?vue&type=template&id=206a9afb&"
import script from "./nested-post-sidebar.vue?vue&type=script&lang=js&"
export * from "./nested-post-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports